import * as React from 'react';

import { FieldValues, UseFormReturn } from 'react-hook-form';

/**
 * Hook pour calculer l'état des verrous de section en temps réel
 */
const useSectionLockStates = (formContext: UseFormReturn<FieldValues, unknown>) => {
    const watchedFields = formContext.watch([
        'numero_facture',
        'date_facture',
        'numero_dossier',
        'numero_dossier_formalite',
        'nom_journal',
        'denomination_societe_formalite',
        'siren_fournisseur',
        'raison_sociale_fournisseur',
        'type_remise_fournisseur',
    ]);

    return React.useMemo(() => {
        const [
            numeroFacture,
            dateFacture,
            numeroDossier,
            numeroDossierFormalite,
            nomJournal,
            denominationSocieteFormalite,
            sirenFournisseur,
            raisonSocialeFournisseur,
            typeRemiseFournisseur,
        ] = watchedFields;

        // La section dossier est déverrouillée si l'en-tête est complété
        const headerCompleted = numeroFacture && dateFacture;

        // La section publisher est déverrouillée si :
        // - Soit le dossier d'annonce est complet (numero_dossier + nom_journal)
        // - Soit le dossier de formalité est complet (numero_dossier_formalite + denomination_societe_formalite)
        const dossierAnnonceCompleted = numeroDossier && nomJournal;
        const dossierFormaliteCompleted = numeroDossierFormalite && denominationSocieteFormalite;
        const dossierCompleted = dossierAnnonceCompleted || dossierFormaliteCompleted;

        // La section products est déverrouillée si le fournisseur est complété
        const publisherCompleted =
            sirenFournisseur && raisonSocialeFournisseur && typeRemiseFournisseur;

        return {
            header: {
                isLocked: false,
                lockMessage: '',
            },
            dossier: {
                isLocked: !headerCompleted,
                lockMessage: "Complétez d'abord les informations d'en-tête",
            },
            publisher: {
                isLocked: !dossierCompleted,
                lockMessage: "Complétez d'abord les informations du dossier",
            },
            products: {
                isLocked: !publisherCompleted,
                lockMessage: "Complétez d'abord les informations du fournisseur",
            },
        };
    }, [watchedFields]);
};

export default useSectionLockStates;
